import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { UtilServico } from '../servicos/util.servico';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { Http } from '@angular/http';
import { DatePipe } from '@angular/common';
import { CertificadoService } from '../servicos/certificado.service';

export interface UrlResponse {
  base_url_api: string;
}

@Component({
  selector: 'app-login-novo',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './login-novo.component.html',
  styleUrls: ['./login-novo.component.scss']
})
export class LoginNovoComponent implements OnInit {

  today: number = Date.now();
  dados: any;
  Carregando: boolean;
  Form: FormGroup;
  Url: string;
  hostname: string;

  validacao_mensagens = {
    usuario: [{ type: 'required', message: 'Usuário é requerido' }],
    senha: [{ type: 'required', message: 'Senha é requerido' }]
  };

  constructor(
    private http: Http, 
    private utilServico: UtilServico, 
    private router: Router, 
    private formBuilder: FormBuilder,
    private certificadoService: CertificadoService,
  ) {

    this.http.get('assets/config.json').subscribe((data:any) => {
      this.Url = data.json().base_url_api;
    });

    this.Carregando = false;
    this.Form = this.formBuilder.group({
      usuario: [null, Validators.required],
      senha: [null, Validators.required]
    });
  }

  ngOnInit() {
    localStorage.removeItem('DadosAcesso');
    this.dados = {};



  }

  AcessarSistema(): void {
    if (this.Form.valid) {

      this.Carregando = true;
      this.utilServico.Login(this.Url, 'LoginAcesso/Autenticar', { login: this.dados.usuario, senha: this.dados.senha }).subscribe(
        (data: any) => {
          
          localStorage.clear();
          localStorage.setItem('DadosAcesso', JSON.stringify(Object.assign(data, { url: this.Url })));
          
          this.utilServico.Get('ParametrosGerais/' + 0).subscribe(
            (data: any) => {
              this.certificadoService.atualizarCertificado(data.DataValidade,true);
              localStorage.setItem('vencimento_certificado' ,data.DataValidade);
            },
            (error: any) => {
              localStorage.setItem('vencimento_certificado' , "");
              this.certificadoService.atualizarCertificado("", false);
            });

          this.router.navigate(['/principal/individual']);

        },
        (error: any) => {

          this.Carregando = false;
          if (error.status == 0) {
            swal.fire({
              title: 'Atenção!',
              type: 'warning',
              text: 'Não foi possível conectar no servidor banco de dados!'
            });
          } else {
            swal.fire({
              title: 'Atenção!',
              type: 'warning',
              text: 'Usuário não encontrado ou senha inválida!'
            });
          }
        }
        
      );
    }
  }
}
